export default __webpack_public_path__ + "static/media/scisports-logo.14a1baf3.svg";